import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Code } from "@/molecules/Code"
import {
  AGENTCORE_STACK_NAME,
  AGENTCORE_TEMPLATE_FILENAME,
  getAgentCoreStackCommand,
  isAgentCoreCodeAccessValid
} from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"
import { DownloadFileButton } from "@/pages/DeploymentsPage/components/molecules/DownloadFileButton"

import type { AgentCoreTemplateProps } from "."

// The CloudFormation template to deploy a new stack with, or to update the
// connected account's stack with, and the command that sets the code access
export const AgentCoreTemplate = (props: AgentCoreTemplateProps) => {
  const { isUpdate, regions, getTemplate, codeAccess } = props
  const accessValid = isAgentCoreCodeAccessValid(codeAccess)
  const command = getAgentCoreStackCommand(regions, codeAccess)
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.agentCore.cloud"
  })

  return (
    <Flex vertical gap={12}>
      <div>
        <DownloadFileButton
          name={AGENTCORE_TEMPLATE_FILENAME}
          getText={getTemplate}
        />
      </div>
      <Text>
        {t(isUpdate ? "template.update" : "template.instructions", {
          stack: AGENTCORE_STACK_NAME,
          region: regions[0]
        })}
      </Text>
      {regions.length > 0 && accessValid && (
        <Code.CommandCard>
          <Code.CommandSnippet
            comment={t("template.stackCommand")}
            instruction=""
            commands={command}
            copyText={command}
          />
        </Code.CommandCard>
      )}
    </Flex>
  )
}
